import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2"

import checkIcon from "../../assets/images/status.svg"
import sortIcon from "../../assets/images/sort.svg"

export const FILTERS = [
    {
        id: uuidv4(),
        title: "Status",
        accessKey: "status",
        options: ["Active", "Inactive"],
        icon: checkIcon
    },
    {
        id: uuidv4(),
        title: "Active purchasing",
        accessKey: "activePurchasing",
        options: ["Active", "Inactive"],
        icon: checkIcon
    }
]

export const TABLE_HEADER_TITLES = [
    {
        id: uuidv4(),
        title: "Username",
        accessKey: "username",
        icon: sortIcon
    },
    {
        id: uuidv4(),
        title: "Role",
        accessKey: "rol",
        icon: sortIcon
    },
    // {
    //     id: uuidv4(),
    //     title: "Active purchasing",
    //     accessKey: "activePurchasing",
    //     icon: sortIcon
    // },
    {
        id: uuidv4(),
        title: "Status",
        accessKey: "status",
        icon: sortIcon
    },
    {
        id: uuidv4(),
        title: "Created at",
        accessKey: "createdAt",
        icon: sortIcon
    },
]

export const PROPERTIES = {
    username: "username",
    rol: "rol",
    status: "disabled",
    activePurchasing: "activePurchasing",
    createdAt: "createdAt"
}

export const ACTIONS = {
    handleSortMobile: "HANDLE_SORT_MOBILE",
    setFilterOpen: "SET_FILTER_OPEN",
    setOptions: "SET_OPTIONS",
}

export function reducer(state, action) {
    switch (action?.type) {
        case ACTIONS.handleSortMobile:
            return {
                ...state,
                openMobileSort: action?.payload ?? !state?.openMobileSort
            }
        
        case ACTIONS.setFilterOpen:
            const filterID = action.payload
            const newFilterOpenValue = state?.openFilter === filterID ? null : filterID

            return {
                ...state,
                openFilter: newFilterOpenValue
            }

        case ACTIONS.setOptions:
            const optionsToSave = state?.optionsOpen === action?.payload ? null : action?.payload

            return {
                ...state,
                optionsOpen: optionsToSave
            }

        default:
            return state
    }
}

export function loadingModal() {
    Swal.fire({
        footer: 'Loading, please wait',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
            Swal.showLoading()
        },
    })
}